import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { RootScopeService } from 'src/app/services/root-scope.service';

@Component({
  selector: 'app-alight-drop-down',
  templateUrl: './alight-drop-down.component.html',
  styleUrls: ['./alight-drop-down.component.scss'],
})
export class AlightDropDownComponent implements OnInit {
  // Below code to be used and to be removed from multiple places once all the dropdowns are made common.
  @ViewChild(MatSelect) select!: MatSelect;
  @HostListener('window:scroll', [])
  onScroll(): void {
    if (this.select?.panelOpen) {
      this.select.close();
    }
  }


  @Input('group') group: FormGroup = new FormGroup({}); //form Group name
  @Input('controlName') controlName: string = ''; //formControlName
  @Input('autofocus') autofocus: boolean = false; //Auto Focus page open time
  @Input('list') list: Array<any> = new Array<any>(); //drop down items
  @Input('label') label: string = 'name'; //label name
  @Input('value') value: string = ''; //Selected drop down value
  @Input('disable') disable: boolean = false; //drop down is disable or enabled
  @Input('required') required: boolean = false; //Drop down selection is required validation
  @Input('description') description: string = '';
  @Input() selectedValue: any;
  @Output() change = new EventEmitter(); //change time event

  constructor(public rootScope: RootScopeService) { }

  ngOnInit(): void { }
  
  typeHeadChange(event) {
    
    this.group.value[this.controlName] = event.value;
    this.change.emit(event);
  }

  /**
   * to close any model popup appear in screen 
   */
  openDropDown() {
    if (this.select?.panelOpen) {
      this.rootScope.dropDown = this.select;
    }
  }
}
